(function ($) {
    'use strict';

    $(window).on("load",function () {

        let userReg = localStorage.getItem("user_reg");
        if (typeof (userReg) !== "undefined" && userReg == "complete_reg" && typeof (kwa) !== "undefined") {
            localStorage.removeItem("user_reg");
            kwa('sendFBEvent', 'CompleteRegistration');
        }
    })

})(jQuery);
